import { render, staticRenderFns } from "./PreLoginInfo.vue?vue&type=template&id=2ac90dba&scoped=true&"
import script from "./PreLoginInfo.vue?vue&type=script&lang=js&"
export * from "./PreLoginInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac90dba",
  null
  
)

export default component.exports